<div class="px-16 py-30">
  <h5 class="color-psr-text-color fw-bold my-0 f16">
    {{ 'login.twoFactor.title' | translate }}
  </h5>
  <p class="f13 mb-30 mt-16">{{ 'login.twoFactor.description' | translate }}</p>
  <p class="text-left f13 mb-16 fw-bold">
    {{ 'login.twoFactor.question' | translate }}
  </p>

  <ps-radio-group
    height="tall"
    name="two-factor"
    [list]="twoFactorType"
    [radioControl]="isPhoneControl">
  </ps-radio-group>

  <p *ngIf="isPhoneControl.value === twoFactor.phone" class="text-left f12 mt-16 mb-8">
    {{ 'login.twoFactor.confirmation' | translate }}
  </p>
  <p *ngIf="isPhoneControl.value === twoFactor.email" class="text-left f12 mt-16 mb-8">
    {{ 'login.twoFactor.confirmationTwo' | translate }}
  </p>

  <p class="text-left f16 mt-8 fw-bold">
    {{ isPhoneControl.value === twoFactor.phone ? phoneText : emailText }}
  </p>
  <ps-button
    buttonClass="mt-16"
    class="w-100"
    data-testid="btn-send"
    height="tall"
    width="100%"
    [text]="'actions.send' | translate"
    (onClick)="sendTwoFactor()">
  </ps-button>

  <div class="divider my-16"></div>

  <ps-button
    class="w-100"
    color="secondary"
    data-testid="btn-return"
    height="tall"
    width="100%"
    [text]="'login.backLogin' | translate"
    (onClick)="returnLogin()">
  </ps-button>
</div>
